// 系统设置=>标签管理
import request from '@/plugins/axios'

const API_LIST = {
  LABEL_LIST: '/customLabel/list',   //标签查询
  LABEL_ADD: '/customLabel/addLabel',    //新增标签
  LABEL_UPDATE: '/customLabel/updateLabel', //修改标签
  LABEL_UPDATE_STATUS: '/customLabel/updateStatus', //修改标签状态
  LABEL_STATISTICS: '/customLabel/labelStatistics', //标签统计


  
}
//获取标签列表
export function getLabelListApi(params) {
  return request({ url: API_LIST.LABEL_LIST, method: 'get', params})
}

//标签统计
export function getLabelStatisticsApi(params) {
  return request({ url: API_LIST.LABEL_STATISTICS, method: 'get', params})
}

//新增标签
export function addLabelApi(data) {
  return request({ url: API_LIST.LABEL_ADD, method: 'post', data})
}

//修改标签信息
export function updateLabelApi(data) {
  return request({ url: API_LIST.LABEL_UPDATE, method: 'post', data})
}

//修改标签状态
export function updateLabelStatusApi(data) {
  return request({ url: API_LIST.LABEL_UPDATE_STATUS, method: 'post', data})
}
